import { useEffect, useState } from "react";
import { getCartLineKey } from "../utils/cartLineKey";

export const useCartEffects = (cartItems = []) => {
    const [selectedLineKeys, setSelectedLineKeys] = useState([]);

    useEffect(() => {
        const available = cartItems.map((item) => getCartLineKey(item));
        setSelectedLineKeys((prev) => {
            const prevSet = new Set(prev);
            const availableSet = new Set(available);
            const kept = prev.filter((key) => availableSet.has(key));
            const missing = available.filter((key) => !prevSet.has(key));
            return [...kept, ...missing];
        });
    }, [cartItems]);

    return { selectedLineKeys };
};
